import React, { Component, createRef } from "react";
import Caroselad from "../Components/carasolead";
import Slider from "react-slick";
import EnquiryFormModal from "../Components/EnquiryFormModal";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from "react-router-dom";
const mgLogo =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/logo%2Fmg-icon-006.webp?alt=media&token=cc8c9019-2e23-443d-9e0a-206b6380069b";

const centralLogo =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/logo%2Fcentrallogo.png?alt=media&token=e222429b-fca4-475a-8079-b41e481e08e9";

const banner1img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2F008-ev-product-bn.webp?alt=media&token=9f5105c6-9fff-4f62-acea-cefbbb77479c";
const banner2img =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/background%2F005-phev-homepage-bn.webp?alt=media&token=ab20883a-b6a6-46d5-975f-fb0ab87722cd";

const banner3img ="https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/0159-herocarousel-bn-dsc.webp?alt=media&token=16f1ba20-e41c-4cdd-b1e1-e38e827081ce"



const inputStyle = {
  width: "100%",
  height: window.innerWidth <= 768 ? "56px" : "60px",
  padding: "0 18px",
  borderRadius: "16px",
  border: "1px solid #e3e3e3",
  background: "#fafafa",
  color: "#111",
  fontSize: window.innerWidth <= 768 ? "15px" : "16px",
  outline: "none",
  boxSizing: "border-box",
};
class Connect extends Component {
  constructor(props) {
    super(props);

    this.sliderRef = createRef();

    this.state = {
      mediaItems: [
        { type: "image", url: banner1img },
        { type: "image", url: banner2img },
        { type: "image", url: banner3img },
      ],
      enquiryOpen: false,
      name: "",
      email: "",
      mobile: "",
      location: "",
      model: "",
      loading: false,
      successMessage: "",
      errorMessage: "",
      otherLocation: "",
    };
  }


  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = async (e) => {

    e.preventDefault();

    const {
      name,
      email,
      mobile,
      location,
      model,
    } = this.state;

    // VALIDATION
    if (
      !name ||
      !email ||
      !mobile ||
      !location ||
      !model ||
      (location === "Other" && !this.state.otherLocation)
    ) {
      this.setState({
        errorMessage: "Please fill all fields",
      });

      return;
    }

    const emailRegex =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {

      this.setState({
        errorMessage: "Invalid email address",
      });

      return;
    }

    const mobileRegex = /^[0-9]{10}$/;

    if (!mobileRegex.test(mobile)) {

      this.setState({
        errorMessage: "Invalid mobile number",
      });

      return;
    }

    try {

      this.setState({
        loading: true,
        errorMessage: "",
        successMessage: "",
      });

      const response = await fetch(
        "https://api.mgcentral.in/api/enquiry/add-enquiry",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
          },

          body: JSON.stringify({
            name,
            email,
            mobile,
            location:
              location === "Other"
                ? this.state.otherLocation
                : location,
            model,
          }),
        }
      );

      const data = await response.json();

      if (
        data.statusCode === 200 ||
        data.statusCode === 201
      ) {

        this.setState({
          loading: false,

          successMessage:
            "Enquiry submitted successfully",

          name: "",
          email: "",
          mobile: "",
          location: "",
          model: "",
          otherLocation: "",
        });

      } else {

        this.setState({
          loading: false,
          errorMessage: data.message,
        });

      }

    } catch (error) {

      this.setState({
        loading: false,
        errorMessage: "Something went wrong",
      });

    }
  };
  // componentDidMount ADD KARO
  componentDidMount() {
    setTimeout(() => {
      this.setState({ enquiryOpen: true });
    }, 2500);
  }

  render() {
    const sliderSettings = {
      dots: true,
      infinite: true,
      speed: 800,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3500,
      arrows: false,
      pauseOnHover: false,
      swipeToSlide: true,
    };

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          fontFamily: "Arial, sans-serif",
          backgroundColor: "#000",
        }}
      >

        {/* Header */}
        <header
          style={{
            backgroundColor: "#000",
            color: "#fff",
            padding: window.innerWidth <= 768 ? "10px 12px" : "10px 22px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            zIndex: 1000,
            boxSizing: "border-box",
          }}
        >
          {/* Left Logos */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: window.innerWidth <= 768 ? "6px" : "10px",
            }}
          >
            {/* MG Logo */}
            <img
              src={mgLogo}
              alt="MG Logo"
              style={{
                height: window.innerWidth <= 768 ? "24px" : "34px",
                width: "auto",
                objectFit: "contain",
              }}
            />

            {/* Central Logo */}
            <img
              src={centralLogo}
              alt="Central Logo"
              style={{
                height: window.innerWidth <= 768 ? "22px" : "32px",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </div>

          {/* Button */}

          <button
            onClick={() => this.setState({ enquiryOpen: true })}
            style={{
              backgroundColor: "#d12230",
              color: "#fff",
              border: "none",
              padding:
                window.innerWidth <= 768 ? "7px 10px" : "9px 14px",
              borderRadius: "4px",
              cursor: "pointer",
              fontWeight: "600",
              fontSize:
                window.innerWidth <= 768 ? "10px" : "12px",
              whiteSpace: "nowrap",
            }}
          >
            Book a Test Drive
          </button>
        </header>

        {/* Main Content */}
        <main
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            marginTop: window.innerWidth <= 768 ? "72px" : "85px",
          }}
        >
          {/* Hero Slider */}
          <div
            style={{
              position: "relative",
              width: "100%",
              backgroundColor: "#000",
            }}
          >
            <Slider ref={this.sliderRef} {...sliderSettings}>
              {this.state.mediaItems.map((item, index) => (
                <div key={index}>
                  <div
                    style={{
                      width: "100%",
                      height:
                        window.innerWidth <= 768
                          ? "auto"
                          : window.innerWidth <= 1024
                            ? "100vh"
                            : "70vh",
                      overflow: "hidden",
                      backgroundColor: "#000",
                    }}
                  >
                    <img
                      src={item.url}
                      alt={`slide-${index}`}
                      style={{
                        width: "100%",
                        height:
                          window.innerWidth <= 768
                            ? "auto"
                            : "100%",
                        objectFit:
                          window.innerWidth <= 768
                            ? "contain"
                            : "cover",
                        objectPosition: "center",
                        display: "block",
                      }}
                    />
                  </div>
                </div>
              ))}
            </Slider>

            {/* Left Arrow */}
            <button
              onClick={() => this.sliderRef.current.slickPrev()}
              style={{
                position: "absolute",
                top: "50%",
                left: "15px",
                transform: "translateY(-50%)",
                background: "rgba(255,255,255,0.6)",
                border: "none",
                width: window.innerWidth <= 768 ? "35px" : "42px",
                height: window.innerWidth <= 768 ? "35px" : "42px",
                borderRadius: "50%",
                cursor: "pointer",
                fontSize: window.innerWidth <= 768 ? "16px" : "20px",
                fontWeight: "bold",
                zIndex: 10,
              }}
            >
              &#10094;
            </button>

            {/* Right Arrow */}
            <button
              onClick={() => this.sliderRef.current.slickNext()}
              style={{
                position: "absolute",
                top: "50%",
                right: "15px",
                transform: "translateY(-50%)",
                background: "rgba(255,255,255,0.6)",
                border: "none",
                width: window.innerWidth <= 768 ? "35px" : "42px",
                height: window.innerWidth <= 768 ? "35px" : "42px",
                borderRadius: "50%",
                cursor: "pointer",
                fontSize: window.innerWidth <= 768 ? "16px" : "20px",
                fontWeight: "bold",
                zIndex: 10,
              }}
            >
              &#10095;
            </button>
          </div>

          {/* ENQUIRY FORM SECTION */}

          <section
            style={{
              width: "100%",
              background: "#fff",
              padding:
                window.innerWidth <= 768
                  ? "35px 14px"
                  : "70px 20px",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              boxSizing: "border-box",
            }}
          >
            <div
              style={{
                width:
                  window.innerWidth <= 768
                    ? "100%"
                    : "80%",

                maxWidth: "850px",

                background: "#fff",

                borderRadius:
                  window.innerWidth <= 768
                    ? "24px"
                    : "20px",

                padding:
                  window.innerWidth <= 768
                    ? "28px 18px"
                    : "50px",

                boxShadow:
                  "0 10px 40px rgba(0,0,0,0.08)",

                border: "1px solid #f1f1f1",

                boxSizing: "border-box",
              }}
            >

              {/* HEADING */}
              <h1
                style={{
                  margin: 0,
                  color: "#111",

                  fontSize:
                    window.innerWidth <= 768
                      ? "34px"
                      : "48px",

                  fontWeight: "800",

                  textAlign: "center",

                  lineHeight: "1.1",
                }}
              >
                ENQUIRE NOW
              </h1>

              <p
                style={{
                  marginTop: "14px",
                  marginBottom: "35px",

                  color: "#666",

                  textAlign: "center",

                  fontSize:
                    window.innerWidth <= 768
                      ? "13px"
                      : "16px",

                  lineHeight: "1.6",

                  letterSpacing: "0.5px",
                }}
              >
                OFFERS | TEST DRIVE | BOOK NOW
              </p>

              {/* SUCCESS */}
              {/* SUCCESS POPUP */}
              {this.state.successMessage && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.7)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 999999,
                    padding: "20px",
                    boxSizing: "border-box",
                  }}
                >
                  <div
                    style={{
                      width:
                        window.innerWidth <= 768
                          ? "92%"
                          : "420px",

                      background: "#fff",

                      borderRadius:
                        window.innerWidth <= 768
                          ? "24px"
                          : "20px",

                      padding:
                        window.innerWidth <= 768
                          ? "35px 22px"
                          : "45px 35px",

                      textAlign: "center",

                      position: "relative",

                      boxShadow:
                        "0 15px 45px rgba(0,0,0,0.2)",

                      animation: "popupShow 0.3s ease",
                    }}
                  >

                    {/* ICON */}
                    <div
                      style={{
                        width: "85px",
                        height: "85px",
                        borderRadius: "50%",
                        background: "#eaf8ee",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "0 auto 22px auto",
                        fontSize: "42px",
                      }}
                    >
                      🙏
                    </div>

                    {/* TITLE */}
                    <h2
                      style={{
                        margin: 0,
                        color: "#111",

                        fontSize:
                          window.innerWidth <= 768
                            ? "30px"
                            : "36px",

                        fontWeight: "800",

                        lineHeight: "1.2",
                      }}
                    >
                      Thank You!
                    </h2>

                    {/* MESSAGE */}
                    <p
                      style={{
                        marginTop: "14px",
                        marginBottom: "30px",

                        color: "#666",

                        lineHeight: "1.7",

                        fontSize:
                          window.innerWidth <= 768
                            ? "14px"
                            : "15px",
                      }}
                    >
                      Your enquiry has been submitted
                      successfully. Our team will
                      contact you shortly.
                    </p>

                    {/* BUTTON */}
                    <button
                      onClick={() =>
                        this.setState({
                          successMessage: "",
                        })
                      }
                      style={{
                        width: "100%",
                        height:
                          window.innerWidth <= 768
                            ? "54px"
                            : "58px",

                        border: "none",

                        borderRadius: "16px",

                        background: "#d91c2b",

                        color: "#fff",

                        fontSize:
                          window.innerWidth <= 768
                            ? "15px"
                            : "16px",

                        fontWeight: "700",

                        cursor: "pointer",

                        transition: "0.3s",
                      }}
                    >
                      OKAY
                    </button>
                  </div>
                </div>
              )}

              {/* ERROR */}
              {this.state.errorMessage && (
                <div
                  style={{
                    background: "#f8d7da",
                    color: "#721c24",
                    padding: "14px",
                    borderRadius: "12px",
                    marginBottom: "18px",
                    textAlign: "center",
                    fontWeight: "600",
                  }}
                >
                  {this.state.errorMessage}
                </div>
              )}

              <form onSubmit={this.handleSubmit}>

                {/* NAME + EMAIL */}
                <div
                  style={{
                    display: "grid",

                    gridTemplateColumns:
                      window.innerWidth <= 768
                        ? "1fr"
                        : "1fr 1fr",

                    gap: "18px",

                    marginBottom: "18px",
                  }}
                >

                  {/* NAME */}
                  <input
                    type="text"
                    required
                    name="name"
                    placeholder="First Name *"
                    value={this.state.name}
                    onChange={this.handleChange}
                    style={inputStyle}
                  />

                  {/* EMAIL */}
                  <input
                    type="email"
                    required
                    name="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    style={inputStyle}
                  />
                </div>

                {/* PHONE */}
                <div style={{ marginBottom: "18px" }}>
                  <input
                    type="tel"
                    required
                    name="mobile"
                    maxLength="10"
                    placeholder="Phone *"
                    value={this.state.mobile}
                    onChange={this.handleChange}
                    style={inputStyle}
                  />
                </div>

                {/* LOCATION */}
                {/* LOCATION */}
                <div style={{ marginBottom: "18px" }}>
                  <select
                    required
                    name="location"
                    value={this.state.location}
                    onChange={this.handleChange}
                    style={inputStyle}
                  >
                    <option value="">
                      Select Location
                    </option>

                    <option value="Bhubaneswar">
                      Bhubaneswar
                    </option>

                    <option value="Cuttack">
                      Cuttack
                    </option>

                    <option value="Berhampur">
                      Berhampur
                    </option>

                    <option value="Jajpur">
                      Jajpur
                    </option>

                    <option value="Other">
                      Other
                    </option>
                  </select>
                </div>

                {/* OTHER LOCATION INPUT */}
                {this.state.location === "Other" && (
                  <div style={{ marginBottom: "18px" }}>
                    <input
                      type="text"
                      required
                      name="otherLocation"
                      placeholder="Enter Your Location"
                      value={this.state.otherLocation}
                      onChange={this.handleChange}
                      style={inputStyle}
                    />
                  </div>
                )}

                {/* MODEL */}
                <div style={{ marginBottom: "26px" }}>
                  <select
                    required
                    name="model"
                    value={this.state.model}
                    onChange={this.handleChange}
                    style={inputStyle}
                  >
                    <option value="">
                      Select Model
                    </option>

                    <option value="MG Hector">
                      MG Hector
                    </option>

                    <option value="Hector Tomahawk EV">
                      Hector Tomahawk EV
                    </option>

                    <option value="Hector Tomahawk PHEV">
                      Hector Tomahawk PHEV
                    </option>

                    <option value="MG Astor">
                      MG Astor
                    </option>

                    <option value="MG Gloster">
                      MG Gloster
                    </option>

                    <option value="MG Windsor">
                      MG Windsor
                    </option>

                    <option value="MG ZS EV">
                      MG ZS EV
                    </option>

                    <option value="MG Comet EV">
                      MG Comet EV
                    </option>
                    <option value="MG Majestor">
                      MG Majestor
                    </option>
                  </select>
                </div>

                {/* BUTTON */}
                <button
                  type="submit"
                  disabled={this.state.loading}
                  style={{
                    width: "100%",

                    height:
                      window.innerWidth <= 768
                        ? "56px"
                        : "62px",

                    borderRadius: "16px",

                    border: "none",

                    background: "#d91c2b",

                    color: "#fff",

                    fontSize:
                      window.innerWidth <= 768
                        ? "15px"
                        : "16px",

                    fontWeight: "700",

                    cursor: "pointer",

                    transition: "0.3s",

                    opacity:
                      this.state.loading
                        ? 0.7
                        : 1,
                  }}
                >
                  {this.state.loading
                    ? "Submitting..."
                    : "SUBMIT ENQUIRY"}
                </button>

              </form>
            </div>
          </section>

          <EnquiryFormModal
            open={this.state.enquiryOpen}
            onClose={() => this.setState({ enquiryOpen: false })}
          />
          {/* Carousel */}
          <Caroselad />
        </main>

        {/* Footer */}
        <footer
          style={{
            backgroundColor: "#000",
            color: "#fff",
            textAlign: "center",
            padding: "15px",
            lineHeight: "20px",
            fontSize: "11px",
          }}
        >
          <div>
            © 2026 mgcentral | Developed and Managed by KLI Advertising
          </div>


          <div style={{ marginTop: "5px" }}>
            <Link
              to="/terms-and-conditions"
              style={{
                color: "#fff",
                textDecoration: "none",
              }}
            >
              Terms and Conditions
            </Link>

            {" / "}

            <Link
              to="/privacy-policy"
              style={{
                color: "#fff",
                textDecoration: "none",
              }}
            >
              Privacy Policy
            </Link>
          </div>
        </footer>
      </div>
    );
  }
}

export default Connect;